class Breadcrumbs {
  constructor () {
    this.init()
  }

  init () {
    const $blockUnderBreadCrumbs = $('.block-under-breadcrumbs')
    const $breadcrumbs = $('.breadcrumbs')
    if ($blockUnderBreadCrumbs.length) {
      if ($blockUnderBreadCrumbs.hasClass('color-white')) {
        $breadcrumbs.addClass('color-white')
      }
    }
  }
}

export default Breadcrumbs
